import { http } from './config'

export default {
    fluxoCaixa: (data) => {
        return http.get(`/v1/relatorio-fluxo-caixa?periodo_inicial=${data.periodo_inicial}&periodo_final=${data.periodo_final}`)
    }
}